import React, { FC, useEffect, useState } from 'react';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles';
import { Box, CircularProgress } from '@material-ui/core';

import Dialog from './dialog';
import api from '../../../api/api';

interface PdfViewProps extends WithStyles<typeof styles> {
  open: boolean;
  setOpen(value: boolean): void;
  title: string;
  url: string;
}

const PdfView: FC<PdfViewProps> = (props) => {
  const { classes, open, setOpen, title, url } = props;
  const [content, setContent] = useState<string>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const id = /\d+$/.exec(url)[0];
    if (!id) {
      return;
    }
    api.file.get(id).then((response) => {
      setContent(response.data);
      setLoading(false);

      let objbuilder = '';
      // objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
      // objbuilder += (response.data);
      // objbuilder += ('" type="application/pdf" class="internal">');
      objbuilder += '<embed src="data:application/pdf;base64,';
      objbuilder += response.data;
      objbuilder += '" type="application/pdf" width="100%" height="100%" />';
      // objbuilder += ('</object>');

      const win = window.open('#', '_blank');
      const title = 'PDF';
      win.document.write(
        '<html><title>' +
          title +
          '</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">'
      );
      win.document.write(objbuilder);
      win.document.write('</body></html>');
    });
  }, [url]);

  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)} title="Соглашение">
        <Box
          my={-2}
          mx={-1}
          minHeight="200px"
          minWidth="400px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {loading && <CircularProgress />}
          {content && !loading && (
            <iframe
              height="100%"
              width="100%"
              src={`data:application/pdf;base64,${content}`}
            />
          )}
        </Box>
      </Dialog>
    </>
  );
};

const styles = (theme: Theme) => createStyles({});

export default withStyles(styles)(PdfView);
